import React, { useEffect, useState } from "react";
import Style from "../../style/featureevent.module.scss";

const FeatureEvent = () => {
  const [data, setData] = useState<any | []>([]);
  useEffect(() => {
    fetch("/data/event.json")
      .then((value) => {
        return value.json();
      })
      .then((res) => {
        setData(res.events);
      });
  }, []);

  const formatEventDate = (start: string, end: string) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    const startDay = startDate.toLocaleDateString("en-US", {
      weekday: "short",
      day: "2-digit",
    });

    const endDay = endDate.toLocaleDateString("en-US", {
      weekday: "short",
      day: "2-digit",
    });

    const monthYear = endDate.toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    });

    return `${startDay} - ${endDay} ${monthYear}`;
  };

  const venueImages = [
    "https://i.ytimg.com/vi/dJVeLpNeR_8/hqdefault.jpg",
    "https://responsive.fxempire.com/v7/_fxempire_/2015/11/china-copper-forexwords.jpg?func=cover&q=70&width=700",
    "https://matcha.so/_next/image?url=https://media.matcha.so/community-logos/79771ecc-55e1-4eba-b5ec-edb204b57310.png&w=256&q=75",
    "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcQp1vU3I14j2dIg-W9Tdj1n3lfwqyjuhnXMWSFwZl49zQpVMTkG",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRfzuwVZJ84H_HNCPa5nzXgKHxJ955EtT4kiggoHg4NX_CSj-uF",
    "https://www.showsbee.com/newmaker/www/u/2023/20237/cfr_img/Immuno-Oncology-Summit.png",
    "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcR5UluIPu4iU6vP5fdc0_UQIrL94mA10NL50ZgjsXWXiuydvM8s",
    "https://media.licdn.com/dms/image/v2/D4D22AQGdZcW9pQiZoA/feedshare-shrink_800/feedshare-shrink_800/0/1705736587487?e=2147483647&v=beta&t=cTe_-jE8gYtf_GwABBLMHEtfGWn2dABIS8z3PQmRnqU",
    "https://m.media-amazon.com/images/I/81Rbyr34zmL._AC_UF1000,1000_QL80_.jpg",
  ];

  return (
    <div className={Style.container}>
      <div className={Style.wrapper}>
        <div className={Style.title}>
          <h2>Featured Events</h2>
          <p>Handpicked popular events</p>
        </div>
        <div className={Style.mainbox}>
          <ul>
            {data.slice(0, 9).map((item: any, index: any) => {
              return (
                <li>
                  <a
                    href={`/event/${item.title
                      .toLowerCase()
                      .replaceAll(" ", "-")}`}
                  >
                    <div className={Style.eventDivide}>
                      <div className={Style.eventFile}>
                        <div className={Style.date}>
                          <h2>
                            {formatEventDate(item.start_date, item.end_date)}
                          </h2>
                        </div>
                        <div className={Style.contentTitle}>
                          <h2>{item.title}</h2>
                        </div>
                        <div className={Style.city}>
                          <h2>
                            {item.venue.city} , <span>{item.venue.state}</span>
                          </h2>
                        </div>
                      </div>
                      <div className={Style.eventImage}>
                        <img src={venueImages[index]} alt={item.venue.name} />
                      </div>
                    </div>
                    <div className={Style.detail}>
                      <div className={Style.category}>
                        {item.categories.map((item: any) => {
                          return <h2>{item}</h2>;
                        })}
                      </div>
                      <div className={Style.Icon}>
                        <i className="fa-solid fa-share-nodes"></i>
                      </div>
                    </div>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        <div className={Style.button}>
          <a href="/login">Add Event</a>
        </div>
      </div>
    </div>
  );
};

export default FeatureEvent;
